export default __webpack_public_path__ + "static/media/r3-project@2x.745ed4af.jpg";